
let routes = [

    {
        path: '/'
        , component: require('./views/AnunciosGenerales.vue').default
    }

];

export default new VueRouter({
    routes
    , linkActiveClass: 'is-active'

})
